// extracted by mini-css-extract-plugin
export default {"surveyTitle":"cViClx62tfqxV8i_","errorText":"FvVuiZtloUIoLGiJ","floatingLabel":"s5WVfdLWv7ClwrPU","error":"JqC8FWptegZuCxiV"};